import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home card shadow p-5 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("h3", { class: "text-danger" }, "You have no access!, Please contact Administrator or your supervisor for more information.", -1),
    _createElementVNode("i", { class: "fad fa-eye-slash fa-5x text-danger mt-5" }, null, -1)
  ])))
}